export { TabNavigator } from './TabNavigator.component';
